import Onyx, { Image as OnyxPreview } from './onyx';
import Pikachu, { Image as PikachuPreview } from './pikachu';
import Gengar, { Image as GengarPreview } from './gengar';
import Castform, { Image as CastformPreview } from './castform';
import Glalie, { Image as GlaliePreview } from './glalie';
import Celebi, { Image as CelebiPreview } from './celebi';

export default [
  {
    key: 'onyx',
    name: 'Sheldon',
    component: Onyx,
    preview: OnyxPreview,
  },
  {
    key: 'pikachu',
    name: 'Leonard',
    component: Pikachu,
    preview: PikachuPreview,
  },
  {
    key: 'gengar',
    name: 'Penny',
    component: Gengar,
    preview: GengarPreview,
  },
  {
    key: 'castform',
    name: 'Howard',
    component: Castform,
    preview: CastformPreview,
  },
  {
    key: 'glalie',
    name: 'Rajesh',
    component: Glalie,
    preview: GlaliePreview,
  },
  {
    key: 'celebi',
    name: 'Amy',
    component: Celebi,
    preview: CelebiPreview,
  },
];
